import { assetRecordApiLookupId, assetRecordPrimaryId } from '../utils/assetRecordPrimaryId';
import {
  assetRecordMatchesDisplayId,
  isAssetShortDisplayId,
} from '../utils/assetShortId';

/** Displayed 8-digit id is not in the active catalog (delisted or never listed). */
export class AssetShortIdNotFoundError extends Error {
  readonly shortId: string;

  constructor(shortId: string) {
    super(`No active listing found for ID ${shortId}.`);
    this.name = 'AssetShortIdNotFoundError';
    this.shortId = shortId;
  }
}

async function findActiveAssetUuidByShortDisplayId(shortId: string): Promise<string | null> {
  const { fetchAllSearchAssetPages } = await import('./assetSearchClient');
  const result = await fetchAllSearchAssetPages({});
  for (const record of result.records) {
    if (!assetRecordMatchesDisplayId(record, shortId)) {
      continue;
    }
    return assetRecordApiLookupId(record) ?? assetRecordPrimaryId(record);
  }
  return null;
}

/**
 * Map a client-facing 8-digit display id to the UUID used by GET `/assets/:id`.
 * Non-short ids are returned unchanged.
 */
export async function resolveAssetLookupId(assetId: string): Promise<string> {
  const trimmed = assetId.trim();
  if (!trimmed) {
    throw new Error('Asset ID is required.');
  }
  if (!isAssetShortDisplayId(trimmed)) {
    return trimmed;
  }
  const uuid = await findActiveAssetUuidByShortDisplayId(trimmed);
  if (!uuid) {
    throw new AssetShortIdNotFoundError(trimmed);
  }
  return uuid;
}
